import {
  HUMAN_PROJECT_DETAILS_BY_ID_LOADING,
  HUMAN_PROJECT_DETAILS_BY_ID_SUCCESS,
  HUMAN_PROJECT_DETAILS_BY_ID_FAILURE,
} from "redux/types";

const initialState = {
  projectDetailsLoading: false,
  projectDetails: null,
  errors: null,
};

export const humanProjectDetailsByIdReducer = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case HUMAN_PROJECT_DETAILS_BY_ID_LOADING:
      return { ...state, projectDetailsLoading: action.payload };
    case HUMAN_PROJECT_DETAILS_BY_ID_SUCCESS:
      return { ...state, projectDetails: action.payload };
    case HUMAN_PROJECT_DETAILS_BY_ID_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
